import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../auth/authApi';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['User', 'UserInvestments', 'Payout'],
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: ({ page = 1, limit = 10, search = '', active = false }) => ({
        url: '/admin-investments/recent',
        params: { 
          page, 
          limit, 
          ...(search && { search }),
          ...(active && { active: true })
        },
      }),
      providesTags: ['User'],
      transformResponse: (response) => {
        return {
          data: response.data,
          pagination: {
            totalUsers: response.pagination.totalUsers,
            totalPages: response.pagination.totalPages,
            currentPage: response.pagination.currentPage
          }
        };
      },
    }),
    getUserInvestments: builder.query({
      query: ({ userId, page = 1, limit = 10 }) => ({
        url: `/admin-investments/user-investment/${userId}`,
        params: { page, limit }
      }),
      providesTags: ['UserInvestments'],
    }),
    sendPayout: builder.mutation({
      query: ({ userId, investmentId }) => ({
        url: '/admin-investments/send-payout',
        method: 'POST',
        body: { userId, investmentId },
      }),
      invalidatesTags: ['Payout', 'UserInvestments'],
    }),
    updateInvestmentStatus: builder.mutation({
      query: ({ investmentId }) => ({
        url: '/admin-investments/update-investment-status',
        method: 'POST',
        body: { investmentId, status: 'completed' },
      }),
      invalidatesTags: ['UserInvestments'],
    }),
    getPayoutHistory: builder.query({
      query: ({ userId, page = 1, limit = 10 }) => ({
        url: `/payout-history/user/${userId}`,
        params: { page, limit }
      }),
      providesTags: ['Payout'],
    }),
  }),
});

export const { 
  useGetUsersQuery,
  useGetUserInvestmentsQuery,
  useSendPayoutMutation,
  useUpdateInvestmentStatusMutation,
  useGetPayoutHistoryQuery
} = userApi;